'use client'

import 'rc-select/assets/index.css'
import './FieldSelect.scss'

import Select, { Option } from 'rc-select'
import React from 'react'

export type IOption = {
  id?: number | string | undefined
  label?: string | undefined
  value: string | null
}

type Props = {
  id?: string
  value: IOption
  options: IOption[]
  onChange: (value: IOption) => void
  placeholder?: string
}

const FieldSelect = ({ id, value, options, onChange, placeholder }: Props) => {
  const handleChange = (optionId: string) => {
    const current = options.find(({ id }) => id?.toString() === optionId)

    onChange(current as IOption)
  }

  return (
    <div className="field-select">
      <div className="field-select__inner">
        <Select
          id={id}
          disabled={!options.length}
          placeholder={placeholder}
          value={value.id as string}
          onChange={handleChange}
        >
          {options.map(({ value, id }, key) => (
            <Option key={key} value={id}>
              {value}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  )
}

export default FieldSelect
